<template>

    <div class="catalog-container">
            <div v-if="isMobile()" class="text-container">
                <h2>Accédez à un catalogue complet de cadeaux</h2>
            </div>
            <div v-else class="text-container">
                <h3><img src="/images/nl_new_home/catalog-slider/gift-icon.svg" alt="gift icon"><div> Choisissez <br> votre <span>cadeau</span></div></h3>
                <h2>Accédez à un catalogue complet de cadeaux</h2>
                <p>Le consommateur devrait toujours avoir le choix. C’est pourquoi, Testachats vous propose de choisir parmi un catalogue de cadeaux variés.</p>
            </div>
        <div v-if="isMobile()" class="slider-container-mobile">
            <Flicking  :plugins="mobilPlugins" :options="{align : 'center' , circular: true}" ref="flicking">
                    <div class="slide" v-for="slide in slides">
                        <a v-if="slide.link" :href="slide.link" target="_blank">
                            <img :src="slide.image_mobile"   :alt="slide.alt"  draggable="false">
                        </a>
                        <img v-else :src="slide.image_mobile" :alt="slide.alt"  draggable="false">
                    </div>
                                <div slot="viewport" class="flicking-pagination"></div>

            </Flicking>
        </div>
        <div v-else class="slider-container">
            <Flicking :plugins="plugins" :options="{ align: 'prev', circular: true, }"  ref="flicking">
                <div class="slider_box">
                    <div class="slide" v-for="(slide, index) in slides" :key="index" v-if="index <= 2">
                        <a v-if="slide.link" :href="slide.link" target="_blank">
                            <img :src="slide.image"   :alt="slide.alt"  draggable="false">
                        </a>
                        <img v-else :src="slide.image" :alt="slide.alt"  draggable="false">
                    </div>
                </div>
                <div class="slider_box">
                    <div class="slide" v-for="(slide, index) in slides" :key="index" v-if="index >2">
                        <a v-if="slide.link" :href="slide.link" target="_blank">
                            <img :src="slide.image" :alt="slide.alt" draggable="false">
                        </a>
                        <img v-else :src="slide.image" :alt="slide.alt" draggable="false">
                    </div>
                </div>
                <div slot="viewport" class="flicking-pagination"></div>

            </Flicking>

        </div>
    </div>
</template>

<script>
import { Flicking } from "@egjs/vue-flicking";
import { Pagination } from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/pagination.css";
import { AutoPlay } from "@egjs/flicking-plugins";

import slider_gift_mixin from "./mixins/slider_gift_mixin";

export default {
    name: "CatalogSlider",
    components: {
        Flicking: Flicking
    },
    mixins: [
        slider_gift_mixin
    ],
    computed: {
        slides() {
            return [
                JSON.parse(this.slider_tablet_archos),
                JSON.parse(this.slider_chromecast),
                JSON.parse(this.slider_senseo),
                JSON.parse(this.slider_soundbar),
                JSON.parse(this.slider_robot),
            ]
        }
    },
    data() {
        return {
            parsedSlides : this.slides,
            plugins: [new Pagination({ type: 'bullet' })],
            mobilPlugins: [new AutoPlay({ duration: 2000,animationDuration : 400, direction: "NEXT", stopOnHover: false })]

        }
    },

    methods: {
        isMobile(){
            return window.innerWidth < 768
        },
    },
}
</script>

<style>

@import url("/node_modules/@egjs/vue-flicking/dist/flicking.css");


</style>
